// extracted by extract-css-chunks-webpack-plugin
module.exports = {"col_box":"col_box-Z1PNYZCf","col_navlist":"col_navlist-zkni1zMw","pa":"pa-3KTPa-Pb"};